import { QueryClient } from "@tanstack/react-query";

/**
 * 
 * @description global tanstack-query config
 */

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Avoid frequent refetching for static or rarely changing data
      staleTime: 0,
      gcTime: 0, // 10 minutes (formerly cacheTime)
      retry: 1, // Retry failed requests up to 2 times
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30000), // Exponential backoff
      refetchOnWindowFocus: false, // Disable refetch on window focus for better performance
      refetchOnReconnect: true, // Refetch on network reconnect
      retryOnMount: false,
    },
    mutations: {
      retry: false, // Fewer retries for mutations to avoid unintended side effects
    },
  },
});
